<div class="row mt-4">
    <div class="col-md-12 fs20 text-center font-bold text-red-600">
        <span>TWO FORMS OF ID ARE REQUIRED TO LODGE TAX RETURNS AS PER ATO</span>
    </div>
</div>

<div class="row">   
       <div class="col-md-5">
        <div class="loading" style="margin-top:15px;">
            <div class="cpanel">
                <div class="cpanel-header">
                    <div class="row" *ngIf="!size.small">
                        <div class="col-12">
                            <div class="cpanel-icon-div">
                                <i class="cpanel-icon far fa-id-badge"></i>
                            </div>
                            <div class="cpanel-title">&nbsp;&nbsp;|&nbsp;&nbsp; SELFIE WITH PHOTO ID IN HAND</div>
                        </div>
                        <div class="col-3 text-right">
                            <!-- <button mat-raised-button class="cpanel-btn" (click)="service.infoDialog('f3', title)">Info</button> -->
                        </div>
                    </div>
                    <table *ngIf="size.small">
                        <tr>
                            <td class="pr10">
                                <i class="cpanel-icon far fa-id-badge"></i>
                            </td>
                            <td>
                                <div class="mobile-title">
                                    SELFIE WITH PHOTO ID IN HAND
                                    <!-- &nbsp; <a mat-button class="mobile-cpanel-info-btn c-light-blue" (click)="service.infoDialog('f3', title)">Info</a> -->
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="cpanel-content">
                    <div class="row" style="margin-bottom: 20px;">
                        <div class="col-md-12 text-center w-full">
                            <img src="assets/images/selfie.jpg" style="height: 100px;" alt="selfie" class="d-block mx-auto" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-center"  *ngIf="invoice.primaryId2 === 0">
                            <a mat-raised-button color="primary" class="cpanel-btn1 c-white fs16" (click)="attachFile(false, 'id0', 'Selfie With Photo ID', 'AF32')"> <i class="fas fa-upload tbl-btn c-dark-grey"></i> &nbsp;Upload - Selfie With Photo ID</a>
                        </div>
                        <div class="col-md-12 text-center" *ngIf="invoice.primaryId2 > 0">
                            <span class="fs14 bold c-success"><i class="fas fa-check-circle"></i> Selfie with Photo ID - Uploaded</span>  
                        </div>
                      
                    </div>
                </div>
            </div>
            <ngx-loading [show]="f3loading"></ngx-loading>
        </div>
    </div>
    <div class="col-md-2 my-auto text-center fs18 bold">
        <!-- == OR == -->
    </div>

    <div class="col-md-5">
        <div class="loading" style="margin-top:15px;">
            <div class="cpanel">
                <div class="cpanel-header">
                    <div class="row" *ngIf="!size.small">
                        <div class="col-12">
                            <div class="cpanel-icon-div">
                                <i class="cpanel-icon far fa-id-badge"></i>
                            </div>
                            <div class="cpanel-title">&nbsp;&nbsp;|&nbsp;&nbsp; TWO FORMS OF ID - COMPULSORY*</div>
                        </div>
                        <div class="col-3 text-right">
                            <!-- <button mat-raised-button class="cpanel-btn" (click)="service.infoDialog('f3', title)">Info</button> -->
                        </div>
                    </div>
                    <table *ngIf="size.small">
                        <tr>
                            <td class="pr10">
                                <i class="cpanel-icon far fa-id-badge"></i>
                            </td>
                            <td>
                                <div class="mobile-title">
                                    TWO FORMS OF ID - COMPULSORY*
                                    <!-- &nbsp; <a mat-button class="mobile-cpanel-info-btn c-light-blue" (click)="service.infoDialog('f3', title)">Info</a> -->
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="cpanel-content">
                    <!-- <div class="row" style="margin-bottom: 20px;">
                        <div class="col-md-12">
                            <span class="fs14 bold c-danger">
                                Please upload one of the below ID
                            </span>
                            <ul class="ml-3 bold fs11">
                                <li><i class="fas fa-star fs10"></i> Australian Driver’s Licence/ Digital Licence </li>
                                <li><i class="fas fa-star fs10"></i> Foreign Driver’s License</li>
                                <li><i class="fas fa-star fs10"></i> Australian Passport</li>
                                <li><i class="fas fa-star fs10"></i> Proof of Age Card</li>
                                <li><i class="fas fa-star fs10"></i> Foreign Passport</li>
                                <li><i class="fas fa-star fs10"></i> International travel documents issued by a foreign government</li>
                                <li><i class="fas fa-star fs10"></i> National Identity card issued by a foreign government</li>
                                <li><i class="fas fa-star fs10"></i> IMMI Card</li>
                            </ul>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col-md-12 text-center"  *ngIf="invoice.primaryId === 0">
                            <a mat-raised-button color="primary" class="cpanel-btn1 c-white fs20" (click)="attachFile(false, 'id1', 'ID Proof - 1', 'AF3')"> <i class="fas fa-upload tbl-btn c-dark-grey"></i> &nbsp;Upload ID Proof 1</a>
                        </div>
                        <div class="col-md-12 text-center" *ngIf="invoice.primaryId > 0">
                            <span class="fs14 bold c-success"><i class="fas fa-check-circle"></i> ID Proof 1 Uploaded</span>  
                        </div>

                        <div class="col-12 my-4 text-center fs18 bold">
                            == & ==
                        </div>

                        <div class="col-md-12 text-center" *ngIf="invoice.secondaryId === 0">
                            <a mat-raised-button color="primary" class="cpanel-btn1 c-white fs20" (click)="attachFile(false, 'id2', 'ID Proof - 2', 'AF3S')"> <i class="fas fa-upload tbl-btn c-dark-grey"></i> &nbsp;Upload ID Proof 2</a>
                        </div>
                        <div class="col-md-12 text-center" *ngIf="invoice.secondaryId > 0">
                            <span class="fs14 bold c-success"><i class="fas fa-check-circle"></i> ID Proof 2 Uploaded</span>  
                        </div>
                        <!-- <div class="col-md-2 col-sm-12 text-center fs14 bold my-auto">
                            <span>Or</span>
                        </div>
                        <div class="col-md-5 col-sm-12 text-center">
                            <a *ngIf="invoice.primaryId === 0" mat-raised-button color="primary" class="cpanel-btn c-white" (click)="attachFile(false, 'Photo ID', 'Photo ID Proof')"> <i class="fas fa-upload tbl-btn c-dark-grey"></i> &nbsp;Other Photo ID</a>
                        </div> -->
                        <!-- <div class="col-md-12 text-center">
                            <a *ngIf="invoice.primaryId === 0" mat-raised-button color="primary" class="cpanel-btn c-white" (click)="attachFile(false, 'Licence', 'Driver Licence Front & Back')"> <i class="fas fa-upload tbl-btn c-dark-grey"></i> Upload Licence</a>
                            <div *ngIf="invoice.primaryId > 0" style="margin-bottom: 10px;">
                                <a class="cpanel-btn bold" (click)="viewFile()" mat-raised-button> <i class="fas fa-search c-success fs14"></i> <span class="c-success bold">&nbsp;View</span></a>
                                <span *ngIf="invoice.statusId < 5">&nbsp;|&nbsp;</span>
                                <a class="cpanel-btn bold" *ngIf="invoice.statusId < 5" (click)="attachFile(true, Licence)" mat-raised-button> <i class="fas fa-redo-alt c-purple fs14"></i> <span class="c-purple bold">&nbsp;Re-Upload</span></a>
                            </div>
                        </div>
                        <div class="col-md-12 text-center">
                            <a *ngIf="invoice.primaryId === 0" mat-raised-button color="primary" class="cpanel-btn c-white" (click)="attachFile(false, 'Photo ID', 'Photo ID Proof')"> <i class="fas fa-upload tbl-btn c-dark-grey"></i> Upload Photo ID</a>
                            <div *ngIf="invoice.primaryId > 0" style="margin-bottom: 10px;">
                                <a class="cpanel-btn bold" (click)="viewFile()" mat-raised-button> <i class="fas fa-search c-success fs14"></i> <span class="c-success bold">&nbsp;View</span></a>
                                <span *ngIf="invoice.statusId < 5">&nbsp;|&nbsp;</span>
                                <a class="cpanel-btn bold" *ngIf="invoice.statusId < 5" (click)="attachFile(true, 'Photo ID')" mat-raised-button> <i class="fas fa-redo-alt c-purple fs14"></i> <span class="c-purple bold">&nbsp;Re-Upload</span></a>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <ngx-loading [show]="f3loading"></ngx-loading>
        </div>
       
    </div>
</div>

<!-- <div class="row">
    <div class="col-md-5">
       
    </div>
    <div class="col-md-1 my-auto text-center fs18 bold">
        == & ==
    </div>
    <div class="col-md-6">
      
    </div>
</div> -->